/**
 * OTA Admin Service
 * Old API to manage software deliverables and OTA updates
 *
 * OpenAPI spec version: v1
 * Contact: man-team-mdm@man.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SemanticVersion } from './semanticVersion';

export interface BundleDeliverableItem { 
    deliverableId: string;
    deliverableVersion: SemanticVersion;
    deliverableType: BundleDeliverableItem.DeliverableTypeEnum;
    sequence: number;
}
export namespace BundleDeliverableItem {
    export type DeliverableTypeEnum = 'DISTRO' | 'APP' | 'FILE' | 'CM4G' | 'BUNDLE';
    export const DeliverableTypeEnum = {
        DISTRO: 'DISTRO' as DeliverableTypeEnum,
        APP: 'APP' as DeliverableTypeEnum,
        FILE: 'FILE' as DeliverableTypeEnum,
        CM4G: 'CM4G' as DeliverableTypeEnum,
        BUNDLE: 'BUNDLE' as DeliverableTypeEnum
    };
}